var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-title"},[_c('div',{staticClass:"l"}),_c('span',{style:({'color':_vm.color})},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"r"})])
}
var staticRenderFns = []

export { render, staticRenderFns }